/**
 * START Course page: Библейский курс START — твой путь к новой жизни с Богом.
 * Static content, events to be added later.
 */

import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layout } from "../../components/layout/index.ts";
import {
  IconClock,
  IconMapPin,
  IconChevronRight,
} from "../../components/Icons.tsx";
import { getTelegram } from "../../lib/telegram.ts";

const BODY_TEXT = `Библейский курс START — твой путь к новой жизни с Богом

Этот курс поможет понять основы веры и построить живые отношения с Богом.

Мы разберём самые важные вопросы:

- Что такое вечная жизнь и как её обрести
- Как оставить прошлое и начать всё заново
- Как понять своё призвание
- Как Слово Божье меняет сердце и жизнь

🗓 Когда: каждую субботу
🕦 Время: 11:30
📍 Где: The Seed Church, Пхукет (iServe Center Thalang, район Банг Тао)

👥 Как проходит: небольшая группа, живое общение, вопросы и ответы

START — это не лекции, а путь к новым открытиям и переменам.

За 5 встреч ты заложишь прочный духовный фундамент, который поможет тебе уверенно двигаться вперёд.`;

function buildImageUrl(url: string | null | undefined): string | null {
  if (!url?.trim()) return null;
  if (url.startsWith("http")) return url;
  return url.startsWith("/") ? url : `/${url}`;
}

export function StartCoursePage() {
  const navigate = useNavigate();
  const tg = getTelegram();
  const imageUrl = buildImageUrl("/content/start-course.png");

  useEffect(() => {
    if (!tg) return;
    tg.BackButton.show();
    const handleBack = () => {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate("/");
      }
    };
    tg.BackButton.onClick(handleBack);
    return () => {
      tg.BackButton.offClick(handleBack);
      tg.BackButton.hide();
    };
  }, [tg, navigate]);

  return (
    <Layout>
      <h1 className="text-xl font-bold text-slate-800 mb-1">
        Библейский курс START
      </h1>
      <p className="text-sm text-slate-500 mb-4">
        Твой путь к новой жизни с Богом
      </p>

      {/* Hero image */}
      {imageUrl ? (
        <div className="aspect-[4/3] overflow-hidden rounded-2xl mb-4 shadow-sm border border-slate-100 ring-1 ring-slate-200/50 bg-slate-100">
          <img src={imageUrl} alt="" className="w-full h-full object-cover" />
        </div>
      ) : null}

      {/* Description */}
      <div className="rounded-2xl overflow-hidden bg-white/95 shadow-sm p-4 xs:p-5 mb-4 border border-slate-100">
        <p className="text-slate-600 text-sm leading-relaxed whitespace-pre-wrap prose prose-slate prose-sm max-w-none">
          {BODY_TEXT}
        </p>
      </div>

      {/* Когда и где — та же локация, что и богослужения */}
      <div className="rounded-2xl overflow-hidden bg-white/95 shadow-sm p-4 xs:p-5 mb-6 border border-slate-100">
        <p className="text-slate-800 font-medium flex items-center gap-2 mb-2">
          <IconClock className="w-5 h-5 text-slate-500 flex-shrink-0" />
          Суббота 11:30
        </p>
        <p className="text-slate-700 flex items-center gap-2 mb-2">
          <IconMapPin className="w-5 h-5 text-slate-500 flex-shrink-0" />
          The Seed Church, Пхукет
        </p>
        <a
          href="https://maps.app.goo.gl/PzT3wFxCMuEDkPtz7?g_st=ipc"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm font-medium text-[var(--color-accent)] no-underline"
        >
          Открыть карту
          <IconChevronRight className="w-4 h-4" />
        </a>
      </div>

      {/* Placeholder for future events */}
      <div className="rounded-2xl overflow-hidden bg-white/80 backdrop-blur-sm shadow-sm p-6 text-center border border-slate-100">
        <p className="text-slate-500 text-sm font-medium uppercase tracking-wider">
          Скоро
        </p>
        <p className="text-slate-600 text-sm mt-1">
          Мероприятия курса появятся здесь
        </p>
      </div>

      <div className="mt-6">
        <Link
          to="/schedule"
          className="flex items-center justify-between gap-3 py-4 px-4 rounded-xl bg-white/95 shadow-sm border border-slate-100 active:bg-slate-50 transition-colors no-underline text-inherit"
        >
          <span className="font-medium text-slate-800">
            Всё расписание на неделю
          </span>
          <IconChevronRight className="w-5 h-5 text-slate-300 flex-shrink-0" />
        </Link>
      </div>

      <div className="h-4" />
    </Layout>
  );
}
